module.exports = __webpack_public_path__ + "static/media/marketing-elephant-mb.ad2bb8c1.png";